export const environment = {
    project: 'explorer',
    production: false,
    name:"staging",
    logLevel: 'TRUE',
    api: 'https://api-preprod.yummypets.com/',
    yummypets: 'https://timmy-preprod.yummypets.com/',
    hmr: false,
    secure: false,
    httpOnly: false,
    tokenKey: '_token_preprod',
    domain: '.yummypets.com',
    googleClientID: '694106264221-klsp19uu51v71213jqs4pbj9dpgrla3t.apps.googleusercontent.com'
};